export class BaseBeneficiaryMeta {
  /**
   * @var {string}
   */
  category;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  addedAsBeneficiaryIn;

  /**
   * @var {boolean}
   */
  estateIsOngoing;

  /**
   * @var {boolean}
   */
  deceasedBeneficiaryHadChildren;

  constructor(model = {}) {
    this.category = model.category;
    this.type = model.type;
    this.addedAsBeneficiaryIn = model.addedAsBeneficiaryIn;
    this.estateIsOngoing = model.estateIsOngoing;
    this.deceasedBeneficiaryHadChildren = model.deceasedBeneficiaryHadChildren;
  }
}
